module.exports = __webpack_public_path__ + "assets/img/010b4f73523e472dbea3625b0d0356cb.png";